import { authConfig } from "../apiConfig";

//FOR GET ALL NOTIFICATONS
export const get_notifications_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`NotificationList`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

//FOR GET ALL NOTIFICATONS
export const get_notifications_without_pagination = async () => {
    try {
        const response = await authConfig.post(`NotificationList`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

//FOR GET ALL NOTIFICATONS
export const notifications_change_status = async (data) => {
    try {
        const response = await authConfig.post(`notificationReadStatus`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// SCHEDULE ACCEPT OR REJECT
export const scheduleAcceptOrReject = async (data) => {
    try {
        const response = await authConfig.post('scheduleAcceptOrNot', data)
        return response.data
    } catch (error) {
        throw error
    }
}